(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-addtocart"] && !Shopify.designMode) return;
  try {
    function initStickyAddToCart() {
    const stickyBtn = document.querySelector('.sticky-addtocart-btn');
    const targetBtn = document.querySelector('.quick-add__submit');
    const stickyWrapper = document.querySelector('.sticky-addtocart-wrapper');

    if (stickyBtn && targetBtn && stickyWrapper) {
      // Initially hide the sticky button with smooth animation
      stickyWrapper.classList.remove('show');

      // Add click event listener
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        targetBtn.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });

      // Intersection Observer to show/hide sticky button
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // Target button is visible, hide sticky button with smooth animation
              stickyWrapper.classList.remove('show');
            } else {
              // Target button is not visible, check if user has scrolled past it
              const targetRect = targetBtn.getBoundingClientRect();
              const viewportHeight = window.innerHeight;
              
              // Only show sticky button if the target button is above the viewport (scrolled past)
              if (targetRect.bottom < 0) {
                stickyWrapper.classList.add('show');
              } else {
                stickyWrapper.classList.remove('show');
              }
            }
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of the target is visible
          rootMargin: '0px 0px 0px 0px'
        }
      );

      observer.observe(targetBtn);
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initStickyAddToCart);

  // Initialize on section load (for dynamic loading)
  document.addEventListener('shopify:section:load', initStickyAddToCart);
  } catch(e) { console.error(e); }
})();

})();
